<template>
    <ErrorPage v-if="libraryUnavailable" />

    <div v-else>
        <b-alert variant="danger" :show="noPermissions"> {{ $t("integrations.media.noPermissions") }} </b-alert>

        <p v-if="$isAdmin() && libraries && libraries.length < 1">
            {{ $t("integrations.media.startByCreating") }} <b-button @click="createLibrary.show = true"
                variant="success"> {{ $t('add') }} </b-button>
        </p>

        <b-row v-if="libraries">
            <b-col xs="12" lg="12">
                <b-row v-if="libraries.length > 0">
                    <b-col sm="12" md="2" class="mb-4">
                        <b-dropdown :text="currentLibName">
                            <b-dropdown-item v-bind:key="lib.uuid" v-for="lib in libraries" @click="changeLib(lib)">
                                <span v-if="lib.name != ''">{{ truncate(lib.name, { length: 15 }) }}</span>
                                <span v-else> {{ $t('default') }} </span>
                            </b-dropdown-item>
                            <b-dropdown-item @click="createLibrary.show = true" v-if="$isAdmin()">
                                {{ $t('add') }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-col>
                </b-row>

                <b-tabs v-if="currentLib">
                    <b-tab :title="$t('theFiles')">
                        <b-form-group>
                            <b-form-input :placeholder="`${$t('search')}...`" @change="search" />
                        </b-form-group>
                        <b-spinner v-if="changingLib" />
                        <b-card show-footer v-else>
                            <div slot="header">
                                <b-row>
                                    <b-col cols="12" class="mb-4">
                                        <h6><a href="#" @click="chdir('')"><i
                                                    class="icon-home icons font-l d-block pull-left"
                                                    style="margin-right: 5px"></i> </a>

                                            <span v-for="(dir, index) in dirPath" v-bind:key="dir">
                                                <a href="#" @click="chdir(dir)"
                                                    v-if="dir != dirPath[dirPath.length - 1]"> {{ dir }} </a>
                                                <span v-else>{{ dir }} </span>
                                                <span v-if="index + 1 != dirPath.length"> / </span>
                                            </span>
                                        </h6>
                                    </b-col>

                                    <b-col cols="12">
                                        <div class="d-md-down-none">
                                            <div class="form-actions pull-right">
                                                <b-button type="submit" variant="success"
                                                    @click="uploadModal.show = true" class="m-2"
                                                    v-if="$can('upload protokol-media')">{{ $t('upload') }}</b-button>
                                                <b-button variant="primary" @click="dirModal.show = true" class="m-2"
                                                    v-if="$can('create_dir protokol-media')">{{ $t('newDirectory') }}
                                                </b-button>
                                                <!-- <b-button  variant="primary" class="m-2" @click="createLibraryFromDirAction" v-if="isProtokolProvider && canCreateLibFromDir">{{ $t('createLibraryFromDir') }}</b-button> -->
                                                <b-button variant="danger" @click="deleteDir"
                                                    v-if="this.currentDir != '' && $can('delete_dir protokol-media')"
                                                    class="m-2">{{ $t('deleteDirectory') }}</b-button>
                                            </div>

                                            <div class="form-actions pull-left" v-if="itemsSelected.length > 0">
                                                <b-button type="submit" variant="success" @click="downloadFile"
                                                    v-if="itemsSelected.length == 1 && $can('download protokol-media')"
                                                    class="m-2">{{ $t('download') }}</b-button>
                                                <b-button type="submit" variant="danger" @click="deleteFile" class="m-2"
                                                    v-if="$can('delete protokol-media')">{{ $t('delete') }}</b-button>
                                            </div>
                                        </div>

                                        <div class="d-block d-sm-none">
                                            <b-dropdown :text="$t('actions')">
                                                <b-dropdown-item @click="uploadModal.show = true"
                                                    v-if="$can('upload protokol-media')">{{ $t('upload')
                                                    }}</b-dropdown-item>
                                                <b-dropdown-item @click="dirModal.show = true"
                                                    v-if="$can('create_dir protokol-media')">{{ $t('newDirectory') }}
                                                </b-dropdown-item>
                                                <b-dropdown-item @click="deleteDir"
                                                    v-if="this.currentDir != '' && $can('delete_dir protokol-media')">{{
                                                        $t('deleteDirectory') }}</b-dropdown-item>
                                                <template v-if="itemsSelected.length > 0">
                                                    <b-dropdown-item @click="downloadFile"
                                                        v-if="itemsSelected.length == 1 && $can('download protokol-media')">{{
                                                            $t('download') }}</b-dropdown-item>
                                                    <b-dropdown-item @click="deleteFile"
                                                        v-if="$can('delete protokol-media')">{{ $t('delete')
                                                        }}</b-dropdown-item>
                                                </template>
                                            </b-dropdown>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                            <b-row v-if="dirs !== undefined">
                                <b-col cols="6" :md="dirSize" v-bind:key="item.name" v-for="item in dirs">
                                    <b-card id="lib-dir" @click="chdir(item.name)">
                                        <b-row align-h="center" style="text-align:center">
                                            <b-col cols="12" md="4">
                                                <i class="icon-cloud-download icons font-2xl"
                                                    v-if="isDirSublib(item.name)"></i>
                                                <i class="icon-folder-alt icons font-2xl" v-else></i>
                                            </b-col>
                                            <b-col cols="12" md="8">
                                                <p>{{ item.name }}</p>
                                            </b-col>
                                        </b-row>


                                    </b-card>
                                </b-col>
                            </b-row>

                            <b-row v-if="items !== undefined">
                                <File v-for="item in files" :file="item" :library="currentLib" :key="item.name"
                                    :itemsSelected="itemsSelected" @selectFile="selectFile" :public="item.public"
                                    :size="fileSize" />
                            </b-row>
                            <scroll-loader :loader-method="getMoreMedia"
                                :loader-disable="disableLoader"></scroll-loader>
                        </b-card>
                    </b-tab>
                    <b-tab :title="$t('settings')" v-if="canShowSettings">
                        <div class="px-3 py-2">
                            <InputField name="name" :label="this.$t('name')" v-model="currentLib.name"
                                @error="fieldError" :rules="{ required: true, length: { min: 2 } }" />

                            <template v-if="!fieldHasError('name')">
                                <SelectField name="roles" :label="this.$t('roles')"
                                    :description="this.$t('allowedRoles')" v-model="currentLib.roles" :items="roles"
                                    :rules="{ required: false }" :multiple="true" />

                                <InputField name="provider" :label="this.$t('provider')"
                                    :value="(currentLib.provider == '') ? 'protokol' : currentLib.provider"
                                    @error="fieldError" :disabled="true"
                                    :rules="{ required: true, length: { min: 2 } }" />
                            </template>

                            <template v-if="currentLib.provider == 's3'">
                                <InputField name="bucket" :label="this.$t('bucket')" v-model="currentLib.s3_bucket"
                                    @error="fieldError" :disabled="true"
                                    :rules="{ required: true, length: { min: 2 } }" />

                                <InputField name="bucket" :label="this.$t('key')" v-model="currentLib.s3_key"
                                    @error="fieldError" :rules="{ required: true, length: { min: 2 } }" />

                                <InputField type="password" name="bucket" :label="this.$t('secret')" v-model="s3Secret"
                                    @error="fieldError" :rules="{ required: true, length: { min: 2 } }" />

                                <InputField name="endpoint" :label="this.$t('endpoint')"
                                    v-model="currentLib.s3_endpoint" @error="fieldError"
                                    :rules="{ required: true, length: { min: 2 } }" />

                                <InputField name="region" :label="this.$t('region')" v-model="currentLib.s3_region"
                                    @error="fieldError" :rules="{ required: true, length: { min: 2 } }" />

                                <InputField name="host" :label="this.$t('host')" v-model="currentLib.host"
                                    @error="fieldError" :rules="{ required: true, length: { min: 2 } }" />

                                <InputField name="Dir" :label="this.$t('rootDir')" v-model="currentLib.dir"
                                    @error="fieldError" :rules="{ required: false }" />
                            </template>

                            <div class="form-actions">
                                <b-button size="sm" variant="success" @click="updateLibrary" class="m-2">{{ $t('save')
                                    }}</b-button>
                                <b-button size="sm" variant="danger" @click="removeLibrary" class="m-2">{{ $t('remove')
                                    }}</b-button>
                            </div>
                        </div>
                    </b-tab>
                </b-tabs>

                <b-modal v-model="uploadModal.show" :ok-title="$t('upload')" ok-variant="success" hide-footer>
                    <b-tabs>
                        <b-tab :title="$t('upload')">
                            <b-form-group>
                                <b-form-file multiple v-model="uploadModal.files"></b-form-file>
                            </b-form-group>

                            <b-form-group :label="this.$t('public')" label-for="public" :label-cols="2"
                                :label-cols-sm="2" :horizontal="false">
                                <c-switch class="mx-1" color="protokol" variant="pill" :label="true" dataOn="Yes"
                                    dataOff="No" v-model="isPublicUpload" />
                            </b-form-group>

                            <b-form-group :label="this.$t('integrations.media.expiresAt')" label-for="expiresAt"
                                :description="$t('integrations.media.expiresAtDescription')" :label-cols="2"
                                :label-cols-sm="2" :horizontal="false">
                                <b-form-datepicker v-model="uploadModal.expiresAt" dark reset-button
                                    :min="new Date()"></b-form-datepicker>
                            </b-form-group>

                            <b-form-group :label-cols="12" :horizontal="false">

                                <template #label>
                                    Metadata <b-button variant="success" size="sm" @click="addMetadata">{{ $t('add')
                                        }}</b-button>
                                </template>

                                <b-row v-for="(d, idx) in uploadModal.metadata" :key="idx" class="mt-1">
                                    <b-col cols="5">
                                        <b-input placeholder="Key" v-model="uploadModal.metadata[idx].key" />
                                    </b-col>

                                    <b-col cols="6">
                                        <b-input placeholder="Value" v-model="uploadModal.metadata[idx].value" />
                                    </b-col>

                                    <b-col cols="1" align-self="center">
                                        <b-icon icon="x" style="font-size: 30px; color: red;"
                                            @click="removeMetadata(idx)" />
                                    </b-col>
                                </b-row>
                            </b-form-group>

                            <b-button variant="success" @click="upload"> {{ $t('upload') }} </b-button>
                        </b-tab>

                        <!-- <b-tab title="Share" >
                        <SelectField name="roles" :label="this.$t('shareVia')" :description="this.$t('shareUploadLink')" v-model="share.type"
                            :items="share.types"
                            :rules="{required:false}"
                        />

                        <DateTimeField name="valid_until" :label="this.$t('validUntil')" :description="this.$t('shareLinkDate')" v-model="share.validUntil"
                            :disablePastDates="true"
                            :minuteStep="5"
                            :rules="{required:true}"
                        />

                        <InputField name="fileName" :label="this.$t('fileName')" v-model="share.key"
                            :rules="{required:true, placeholder: 'example.pdf', length: {min: 2}}"
                        />

                        <SelectField name="mimeType" label="Mime Type" description="Choose allowed mime type for file" v-model="share.mimeType"
                            :items="['image/png']"
                            :rules="{required:false}"
                        /> 

                        <b-form-group
                            v-if="share.type == 'email'"
                            :label="this.$t('emails')"
                            label-for="emails"
                            :label-cols="2"
                            :label-cols-sm="2"
                            :description="this.$t('emailsSeparated')"
                            :horizontal="false">
                            <b-textarea v-model="share.emails" />
                        </b-form-group>

                        <InputField name="share_url" :label="this.$t('shareUrl')" :value="share.url"
                            :disabled="true"
                            :rules="{required:true, length: {min: 2}}"
                            v-if="share.url !== null && share.type == 'link'"
                        />

                        <b-button variant="success" @click="shareUpload"> {{ $t('share') }} </b-button>
                    </b-tab> -->
                    </b-tabs>
                </b-modal>

                <b-modal :title="$t('newDirectory')" v-model="dirModal.show" :ok-title="$t('create')"
                    ok-variant="success" @ok="createDir">
                    <InputField name="name" :label="this.$t('name')" v-model="dirModal.name" @error="fieldError"
                        :rules="{ required: true, length: { min: 2 } }" />
                </b-modal>

                <b-modal :title="$t('moveToDirectory')" v-model="moveModal.show" :ok-title="$t('move')"
                    ok-variant="success" @ok="moveFiles">
                    <SelectField name="dir" :label="this.$t('directory')" v-model="moveModal.dir" @error="fieldError"
                        :items="deepDirs" :rules="{ required: true }" />
                </b-modal>
            </b-col>
        </b-row>

        <b-skeleton v-else width="100%" height="250px" animation="throb" />

        <b-sidebar v-model="createLibrary.show" right backdrop>
            <div class="px-3 py-2">
                <InputField name="name" :label="this.$t('name')" v-model="createLibrary.data.name" @error="fieldError"
                    :rules="{ required: true, length: { min: 2 } }" />

                <template v-if="!fieldHasError('name')">
                    <SelectField name="roles" :label="this.$t('roles')" :description="this.$t('allowedRoles')"
                        v-model="createLibrary.data.roles" :items="roles" :rules="{ required: false }"
                        :multiple="true" />

                    <SelectField name="provider" :label="this.$t('provider')"
                        :description="this.$t('chooseMediaProvider')" v-model="createLibrary.data.provider"
                        :items="libProviders" :reduce="(o) => o" :rules="{ required: true }" />
                </template>

                <!-- <div v-if="createLibrary.data.provider == 'protokol-simple'">
                {{  $t('integrations.media.protokolSimpleDescription')  }}
            </div> -->

                <template v-if="createLibrary.data.provider == 's3'">
                    <InputField name="endpoint" :label="this.$t('endpoint')" v-model="createLibrary.data.s3_endpoint"
                        @error="fieldError" :rules="{ required: true, length: { min: 2 } }" />

                    <InputField name="region" :label="this.$t('region')" v-model="createLibrary.data.s3_region"
                        @error="fieldError" :rules="{ required: true, length: { min: 2 } }" />

                    <InputField name="bucket" :label="this.$t('bucket')" v-model="createLibrary.data.s3_bucket"
                        @error="fieldError" :rules="{ required: true, length: { min: 2 } }" />

                    <InputField name="key" :label="this.$t('key')" v-model="createLibrary.data.s3_key"
                        @error="fieldError" :rules="{ required: true, length: { min: 2 } }" />

                    <InputField type="password" name="secret" :label="this.$t('secret')"
                        v-model="createLibrary.data.s3_secret" @error="fieldError"
                        :rules="{ required: true, length: { min: 2 } }" />

                    <InputField name="host" :label="this.$t('host')" v-model="createLibrary.data.host"
                        @error="fieldError" :description="this.$t('libraryPublicUrl')"
                        :rules="{ required: true, placeholder: 'https://library.example.com', length: { min: 2 } }" />

                    <InputField name="dir" :label="this.$t('rootDirMedia')" v-model="createLibrary.data.dir"
                        @error="fieldError" :description="this.$t('rootDirMedia')"
                        :rules="{ required: false, length: { min: 2 } }" />
                </template>
            </div>
            <template #footer>
                <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
                    <b-button size="sm" variant="success" @click="createLibraryAction" v-if="canShowCreate">{{
                        $t('create') }}</b-button>
                    <protokol-checkout-button size="sm" v-if="canShowBuy" productType="integration"
                        reference="protokol-media">{{ $t('buy') }}</protokol-checkout-button>
                </div>
            </template>
        </b-sidebar>
    </div>
</template>

<style scoped>
#lib-file,
#lib-dir {
    overflow: hidden;
}

#lib-dir p {
    padding: 5px 0px 0px 0px;
    margin: 0;
}

#lib {
    cursor: pointer;
}

#lib.selected {
    border: 2px solid #20a8d8 !important;
}

#lib i {
    float: left;
    padding: 0px 15px 0px 0px;
}

#lib p {
    padding: 5px 0px 0px 0px;
    margin: 0;
}

#lib small {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 5px;
    font-size: 10px;
    color: #ccc;
}
</style>
<script>
import Input from "@/components/form/Input"
import Select from "@/components/form/Select"
import Page500 from "../../../../views/pages/Page500"
import HelptipPopup from "../../../elements/HelptipPopup"
import _ from "lodash"
import File from "./File"
import { Switch as cSwitch } from '@coreui/vue'
//import DateTime from "@/components/form/DateTime"

export default {
    name: "Media",
    props: {
        mode: {
            type: String,
            default: 'library'
        }
    },

    components: {
        InputField: Input,
        SelectField: Select,
        ErrorPage: Page500,
        File,
        HelptipPopup,
        cSwitch,
        //DateTimeField: DateTime
    },
    data: function () {
        return {
            libraryUnavailable: false,
            ready: false,
            noPermissions: false,
            changingLib: false,
            errors: [],
            dirPath: [],
            itemsSelected: [],
            keyword: '',
            uploadModal: {
                show: false,
                files: [],
                metadata: [],
                expiresAt: null
            },
            dirModal: {
                show: false,
                name: ''
            },
            moveModal: {
                show: false,
                dir: ''
            },
            storage: {
                allowedSpace: 0,
                freeSpace: 0
            },
            editLibrary: {
                show: false,
                data: null
            },
            createLibrary: {
                show: false,
                data: {
                    name: '',
                    roles: []
                }
            },
            roles: [],
            isPublicUpload: false,
            share: {
                types: ['link', 'email'],
                type: 'link',
                url: null,
                emails: '',
                validUntil: '',
                mimeType: 'application/octet-stream',
                key: ''
            },

            dirs: [],

            searchedItems: null,
            lastKey: null,
            disableLoader: false,
            limit: 12
        }
    },
    watch: {
        "fileModal.data.orig_name": function (nVal, oVal) {
            this.fileModal.data.orig_name = nVal.replace(" ", "_");
        },
        "dirModal.name": function (nVal, oVal) {
            this.dirModal.name = nVal.replace("/", "");
        },
    },
    computed: {
        items() {
            if (this.searchedItems) {
                return this.searchedItems
            }

            return this.$store.getters.media(this.currentDir)
        },

        files() {
            if (this.items) {
                let items = this.items.filter(f => {
                    return f.mime_type != "dir"
                })

                return items
            }
        },

        deepDirs() {
            return this.$store.getters.dirs.filter(d => {
                if (d == ".") {
                    return d != this.currentDir
                } else {
                    return "/" + d != this.currentDir
                } x

            })
        },

        currentDir() {
            return this.dirPath.join("/")
        },

        prevDir() {
            return this.dirPath[this.dirPath.length - 2]
        },

        dirSize() {
            if (this.mode == "library") return 3
            return 4
        },

        fileSize() {
            if (this.mode == "library") return 2
            return 3
        },

        getOccupiedSpace() {
            let lib = this.$store.getters.library
            if (lib !== null) {
                let l = (lib.allowed_storage / (lib.allowed_storage - lib.size)) / 100

                return l.toFixed(2)
            }
        },

        freeSpace() {
            return 100 - this.getOccupiedSpace
        },

        libraries: {
            set(val) {
                this.$store.commit("SET_LIBRARIES", val)
            },

            get() {
                return this.$store.getters.libraries
            }
        },

        currentLib: {
            set(val) {
                this.$router.replace({
                    query: {
                        lib: val.uuid
                    }
                });

                this.$store.commit("SET_LIBRARY", val)
            },

            get() {
                let lib = this.$route.query.lib
                if (lib === undefined) {
                    return this.$store.getters.library
                }

                return this.libraries.find(l => {
                    return l.uuid == lib
                })
            }
        },

        libProviders() {
            let providers = [
                'protokol-simple'
            ]

            const libs = this.libraries || []
            const exist = libs.find(l => {
                return l.provider == 'protokol-simple'
            })

            if (exist) {
                providers.pop()
            }

            return providers
        },

        canCreateLibFromDir() {
            if (this.currentLib.dir.substring(0, 1) == "$") {
                return false
            }

            if (this.currentDir == "") {
                return false
            }

            let find = this.libraries.find(l => {
                return l.dir == "$/" + this.currentLib.uuid + this.currentDir
            })

            if (find !== undefined) {
                return false
            }

            return true
        },

        s3Secret: {
            get() {
                return '__secret__'
            },

            set(val) {
                this.currentLib.s3_secret = val
            }
        },

        canShowSettings() {
            return this.$route.path.includes("/integrations/page/protokol-media")
        },

        currentLibName() {
            if (this.currentLib) {
                if (this.currentLib.name != '') {
                    return this.truncate(this.currentLib.name, { length: 15 })
                }

                return this.$t('default')
            }
        },

        canShowBuy() {
            if (this.createLibrary.data.provider == 'protokol-simple') {
                let integration = this.$store.getters.getIntegrationByID('protokol-media')
                let subs = this.$store.getters.getSubscriptions || []

                let sub = subs.find(s => {
                    return s.product_id == integration.template.product_id
                })

                if (sub) {
                    return false
                }

                return true
            }

            return false
        },

        canShowCreate() {
            if (this.canShowBuy) return false

            let libs = this.libraries || []
            return libs.find(l => {
                return l.provider == 'protokol-simple'
            }) === undefined
        },

        metadata() {
            const metadata = this.uploadModal.metadata
            let formated = {}

            metadata.forEach(v => {
                formated[v.key] = v.value
            })

            return formated
        }
    },
    methods: {
        fieldHasError(field) {
            const res = this.errors.find(f => {
                return f.field == field && f.error
            }) !== undefined

            return res
        },

        truncate: _.truncate,

        getMoreMedia() {
            this.$store.dispatch("fetchMedia", { path: this.currentDir, uuid: this.currentLib.uuid, last_key: this.lastKey, limit: this.limit }).then((data) => {
                //this.chdir(this.currentDir)

                const lastItem = data.pop()
                if (lastItem)
                    this.lastKey = lastItem.key

                if ((data.length + 1) < this.limit) this.disableLoader = true

            }).catch(error => {
                if (error.response !== undefined) {
                    if (error.response.status == 500) {
                        this.$serverErrorModal(error)
                        return
                    }
                }

                console.log(error.message);
            })
        },

        chdir(dir) {
            this.dirs = []
            this.lastKey = null
            this.searchedItems = null
            let index = this.dirPath.indexOf(dir)

            if (index == -1) {
                this.dirPath.push(dir)
            } else {
                this.dirPath = this.dirPath.slice(0, index + 1)
            }

            this.itemsSelected = []

            if (this.$route.path == "/admin/integrations/page/protokol-media") {
                history.pushState(null, null, '#' + this.currentDir);
            }

            const lastItemInPath = this.$store.getters.getLastItemInDir(this.currentDir)
            if (lastItemInPath) {
                this.lastKey = lastItemInPath.key
            }

            this.disableLoader = false

            this.$store.dispatch("fetchDirs", { path: this.currentDir, uuid: this.currentLib.uuid }).then(resp => {
                this.dirs = resp
            })
        },

        upload() {
            const popup = this.$loadingPopup()

            const data = {
                files: this.uploadModal.files,
                currentDir: this.currentDir,
                ref: this.currentLib.uuid,
                isPublic: this.isPublicUpload,
                expiresAt: this.uploadModal.expiresAt,
                metadata: this.metadata
            }

            this.$media.upload(data).then((resp) => {
                if (!resp) {
                    this.$bvToast.toast(this.$t('uploadInBackground'), {
                        variant: 'warning'
                    })

                    return
                }

                this.$store.commit("APPEND_MEDIA", { path: this.currentDir, results: resp.data })
                this.uploadModal.show = false
            }).catch(error => {
                this.$debugLog(error)

                if (error.response) {
                    if (error.response.status == 500) {
                        this.$serverErrorModal(error)
                        return
                    }

                    this.$bvModal.msgBoxOk(error.response.data.message)
                }

            }).finally(() => {
                this.uploadModal.show = false
                popup.hide()
            })
        },

        shareUpload(e) {
            if (this.share.type == 'link')
                e.preventDefault();

            this.$media.share(this.currentLib.uuid, { key: this.currentDir + "/" + this.share.key, mimeType: this.share.mimeType, date: this.share.validUntil }).then(resp => {
                //console.log(resp)
                this.share.url = resp.data
                this.share.validUntil = ''
                this.share.key = ''
            }).catch(error => {
                if (error.response !== undefined) {
                    if (error.response.status == 500) {
                        this.$serverErrorModal(error)
                        return
                    }

                    this.$bvModal.msgBoxOk(error.response.message)
                }
            })
        },

        downloadFile() {
            let item = this.itemsSelected[0]
            this.$media.download(this.currentLib.uuid, item.key).then(resp => {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', item.name); //or any other extension
                document.body.appendChild(link);
                link.click();
            }).catch(err => {
                console.log(err)
            })
        },

        createDir() {
            if (this.checkForErrors()) {
                this.$bvModal.msgBoxOk(this.$t("someFieldsAreNotValid"))

                return
            }

            this.$media.createDir(this.currentLib.uuid, this.currentDir + "/" + this.dirModal.name).then(resp => {
                this.dirs.push({
                    mime_type: 'dir',
                    name: this.dirModal.name
                })

                this.dirModal.name = ''
            }).catch(err => {
                if (err.response === undefined) {
                    this.$bvModal.msgBoxOk(err.message)
                    return
                }

                if (err.response.status == 500) {
                    this.$serverErrorModal(err)
                    return
                }

                this.dirModal.name = ''

                this.$bvModal.msgBoxOk(err.response.data.message)
            })
        },

        deleteDir() {
            this.$bvModal.msgBoxConfirm(this.$t("actionWillRemoveDirAndContents")).then(resp => {
                if (resp) {
                    let dirToDelete = _.trimStart(this.currentDir, "/")

                    this.$media.deleteDir(this.currentLib.uuid, dirToDelete).then(resp => {
                        this.$store.commit("REMOVE_DIR", this.currentDir)
                        this.chdir(this.prevDir)
                        // refresh library info to check for available storage
                        //this.$store.dispatch("fetchLibraryInfo")
                    }).catch(err => {
                        if (err.response === undefined) {
                            this.$bvModal.msgBoxOk(err.message)
                            return
                        }

                        if (err.response.status == 500) {
                            this.$serverErrorModal(err)
                            return
                        }

                        this.$bvModal.msgBoxOk(err.response.message)
                    })
                }
            })

        },

        isDirSublib(dir) {
            let find = this.libraries.find(l => {
                return l.dir == "$/" + this.currentLib.uuid + this.currentDir + "/" + dir
            })

            if (find !== undefined) {
                return true
            }

            return false
        },

        selectFile(e, item) {
            if (e.ctrlKey || e.metaKey) {
                let find = this.itemsSelected.find(id => {
                    return item.uuid == id
                })

                if (find === undefined) {
                    this.itemsSelected.push(item)
                } else {
                    this.itemsSelected = this.itemsSelected.filter(id => {
                        return item.uuid != id
                    })
                }
            } else {
                this.itemsSelected = [item]
            }

            this.$emit("itemsSelected", this.itemsSelected)
        },

        editFile() {
            let item = this.itemsSelected[0]
            if (item !== undefined) {
                let file = this.$store.getters.mediaFile(this.currentDir, this.itemsSelected[0])

                this.fileModal.title = file.orig_name
                this.fileModal.data = file
                this.fileModal.show = true
            }
        },

        deleteFile() {
            this.$bvModal.msgBoxConfirm(this.$t("selectedFilesWillBeDeleted")).then(resp => {
                if (resp) {
                    let popup = this.$loadingPopup(this.$t('deleting') + "...")

                    this.$media.delete({ ref: this.currentLib.uuid, items: this.itemsSelected }).then((resp) => {
                        this.itemsSelected = []

                        resp.data.forEach(d => {
                            this.$store.commit("REMOVE_MEDIA", d)
                        })
                    }).catch(error => {
                        if (error.response !== undefined) {
                            if (error.response.status == 500) {
                                this.$serverErrorModal(error)
                                return
                            }

                            this.$bvModal.msgBoxOk(error.response.message)
                        }

                        throw error

                    }).finally(() => {
                        popup.hide()
                    })
                }
            })
        },

        moveFiles() {
            this.$bvModal.msgBoxConfirm($t('filesWillBeMovedToSelectedDir')).then(resp => {
                if (resp) {
                    let moveToDir = this.moveModal.dir
                    if (moveToDir == ".") {
                        moveToDir = ""
                    }

                    if (moveToDir != "") {
                        moveToDir = "/" + moveToDir
                    }

                    this.$mediaHttp.post("/media/move", { path: moveToDir, items: this.itemsSelected }).then(resp => {
                        this.$store.commit("MOVE_MEDIA", { from: this.currentDir, to: moveToDir, items: this.itemsSelected })
                    })
                }
            })
        },

        search: _.debounce(function (e) {
            if (e == "") {
                this.searchedItems = null
                this.$store.dispatch("fetchMedia", { path: this.currentDir, uuid: lib }).catch(err => {
                    this.$bvModal.msgBoxOk(err.message, { noStacking: true })
                    this.chdir('')
                }).catch(error => {
                    if (error.response !== undefined) {
                        if (error.response.status == 500) {
                            this.$serverErrorModal(error)
                            return
                        }

                        return
                    }
                })

                return
            }

            this.$store.dispatch("searchMedia", { path: this.currentDir, uuid: this.currentLib.uuid, keyword: e })
                .then(resp => {
                    this.searchedItems = resp
                })
                .catch(error => {
                    if (error.response !== undefined) {
                        if (error.response.status == 500) {
                            this.$serverErrorModal(error)
                            return
                        }
                    }

                    this.$debugLog(error.message);
                })
        }, 500),


        isSelected(uuid) {
            return this.itemsSelected.indexOf(uuid) !== -1
        },

        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },

        changeLib(lib) {
            this.changingLib = true
            this.$store.commit("CLEAN_MEDIA")
            this.currentLib = lib
            this.chdir('')
            this.lastKey = null

            this.$store.dispatch("fetchLibraryInfo", lib.uuid).then(data => {
                this.storage.allowedSpace = data.allowed_storage
                this.storage.size = data.size
                this.storage.freeSPace = data.allowed_storage - data.size

                this.ready = true
                this.$store.dispatch("fetchMedia", { path: this.currentDir, uuid: lib.uuid })
                    .then(() => {
                        try {
                            this.$router.replace({ query: { lib: lib.uuid } })
                        } catch {

                        }

                        this.changingLib = false
                    })
                    .catch(err => {
                        this.$bvModal.msgBoxOk(err.message, { noStacking: true })
                        this.chdir('')
                    })
                    .catch(error => {
                        if (error.response !== undefined) {
                            if (error.response.status == 500) {
                                this.$serverErrorModal(error)
                                return
                            }

                            return
                        }
                    })
            }).catch(error => {
                if (error.response !== undefined) {
                    if (error.response.status == 500) {
                        this.$serverErrorModal(error)
                        return
                    }

                    return
                }

                if (!error.status) {
                    this.libraryUnavailable = true
                }

            })


        },

        createLibraryAction() {
            this.$mediaHttp.post("/v1/media/library", this.createLibrary.data).then(resp => {
                this.$bvToast.toast(this.$t('libraryCreated'), {
                    variant: 'success',
                    title: this.$t('success')
                })

                this.$store.commit("ADD_LIBRARY", resp.data)

                this.createLibrary.show = false
                this.createLibrary.data = {}
            }).catch(error => {
                this.$debugLog(error)
                if (error.response !== undefined) {
                    if (error.response.status == 500) {
                        this.$serverErrorModal(error)
                        return
                    }

                    this.$bvModal.msgBoxOk(error.response.data.message)

                    return
                }
            })
        },

        createLibraryFromDirAction() {
            let data = {
                name: this.dirPath[this.dirPath.length - 1],
                provider: this.currentLib.provider,
                dir: this.currentDir,
                roles: []
            }

            this.$mediaHttp.post("/v1/media/library", data).then(resp => {

                this.$bvToast.toast(this.$t('libraryCreated'), {
                    variant: 'success',
                    title: "Success"
                })

                this.$store.commit("ADD_LIBRARY", resp.data)

                this.createLibrary.show = false
                this.createLibrary.data = {}
            }).catch(error => {
                if (error.response !== undefined) {
                    if (error.response.status == 500) {
                        this.$serverErrorModal(error)
                        return
                    }

                    this.$bvModal.msgBoxOk(error.response.data.message)

                    return
                }
            })
        },

        editLib(lib) {
            this.editLibrary.show = true
            this.editLibrary.data = lib
        },

        updateLibrary() {
            if (this.checkForErrors()) {
                this.$bvModal.msgBoxOk(this.$t('someFieldsAreNotValid'))

                return
            }


            this.$mediaHttp.post("/v1/media/library/" + this.currentLib.uuid, this.currentLib).then(resp => {

                this.$bvToast.toast(this.$t('librarySettingsUpdated'), {
                    variant: 'success',
                    title: "Success"
                })

                this.currentLib = resp.data
                this.currentLib.roles = this.currentLib.roles.map(r => {
                    return r.role_uuid
                })
            }).catch(error => {
                if (error.response !== undefined) {
                    if (error.response.status == 500) {
                        this.$serverErrorModal(error)
                        return
                    }

                    return
                }

                this.$bv.msgBoxOk(this.$t('failedToUpdateLibrary'))
            })
        },

        removeLibrary() {
            this.$bvModal.msgBoxConfirm(this.$t('actionWillRemoveLibrary')).then(resp => {
                if (resp) {
                    this.$mediaHttp.delete("/v1/media/library/" + this.currentLib.uuid).then(() => {

                        this.$bvToast.toast(this.$t('libraryRemoved'), {
                            variant: 'success',
                            title: "Success"
                        })

                        this.libraries = this.libraries.filter(l => {
                            return l.uuid != this.currentLib.uuid
                        })

                        if (this.libraries.length > 0) {
                            this.changeLib(this.libraries[0])
                        } else {
                            this.libraries = null
                        }
                    }).catch(error => {
                        if (error.response !== undefined) {
                            if (error.response.status == 500) {
                                this.$serverErrorModal(error)
                                return
                            }

                            return
                        }

                        this.$bv.msgBoxOk(this.$t('failedToRemoveLibrary'))
                    })
                }
            })
        },

        isProtokolProvider() {
            return this.currentLib.provider == ""
        },

        isLibSelected(lib) {
            if (this.currentLib) {
                return this.currentLib.uuid == lib.uuid
            }

            return false
        },

        buy() {
            const popup = this.$loadingPopup()

            this.$transactionApi.post("/checkout/link", {
                product_type: "integration",
                reference: "protokol-media",
                lang: this.$store.getters.getLocale,
                source: `platform`
            }).then(resp => {
                window.open(resp.data, '_blank')
            }).catch(err => {
                this.processInfo = false

                if (err.response) {
                    if (err.response.status == 501) {
                        this.$bvToast.toast(this.$t('checkoutMethodCurrentlyDisabled'), {
                            title: this.$t('error'),
                            variant: 'danger'
                        })
                        return
                    }
                }

                this.$bvModal.msgBoxOk(this.$t('failedToCheckout'))
            }).finally(() => {
                popup.hide()
            })
        },

        addMetadata() {
            this.uploadModal.metadata.push({ key: "", value: "" })
        },

        removeMetadata(idx) {
            this.uploadModal.metadata.splice(idx, 1)
        }
    },
    mounted() {
        if (!this.$can("use protokol-media")) {
            this.noPermissions = true
            return
        }

        this.dirPath = [""]
        if (this.$route.path == "/admin/integrations/page/protokol-media") {
            let dirpath = window.location.href.split('#')[1]
            if (dirpath !== undefined) {
                this.dirPath = dirpath.split("/")
            }
        }

        this.$store.dispatch("fetchRoles").then(data => {
            this.roles = data || []
            this.roles.map(el => {
                el.text = el.name
                el.value = el.uuid
            })
        }).catch(error => {
            if (error.response.status == 500) {
                this.$serverErrorModal(error)
                return
            }
        })

        this.$store.dispatch("fetchLibraries").then((libs) => {
            let lib = this.$route.query.lib
            if (lib === undefined && libs.length > 0) {
                lib = libs[0].uuid
            }

            if (lib !== undefined && libs.length > 0) {
                this.$store.dispatch("fetchDirs", { path: this.currentDir, uuid: lib }).then(resp => {
                    this.dirs = resp
                })

                this.$store.dispatch("fetchLibraryInfo", libs[0].uuid).then(data => {
                    this.storage.allowedSpace = data.allowed_storage
                    this.storage.size = data.size
                    this.storage.freeSPace = data.allowed_storage - data.size

                    this.ready = true
                }).catch(error => {
                    console.log(error)
                    if (error.response !== undefined) {
                        if (error.response.status == 500) {
                            this.$serverErrorModal(error)
                            return
                        }

                        this.libraryUnavailable = true
                        return
                    }

                    if (!error.status) {
                        this.libraryUnavailable = true
                    }

                })
            }


        }).catch(err => {
            this.libraryUnavailable = true
            this.$debugLog(err)
        })

        let checkoutPage = new BroadcastChannel('checkout')
        checkoutPage.onmessage = (msg) => {
            if (msg.data.type == "checkout_finished") {
                this.createLibraryAction()
            }
        }
    }
}
</script>
